import { render, staticRenderFns } from "./PublicClassDetail.vue?vue&type=template&id=633113a4&scoped=true"
import script from "./PublicClassDetail.vue?vue&type=script&lang=js"
export * from "./PublicClassDetail.vue?vue&type=script&lang=js"
import style0 from "./PublicClassDetail.vue?vue&type=style&index=0&id=633113a4&prod&scoped=true&lang=scss"
import style1 from "./PublicClassDetail.vue?vue&type=style&index=1&id=633113a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633113a4",
  null
  
)

export default component.exports